import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import req from "../../axios/interceptedAxiosInstance";

export const getUserCart = createAsyncThunk("cart/getUserCart", async () => {
  const response = await req.get("cart/fetch");
  return response.data.data;
});

const initialState = {
  cart: [],
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItemToCart: (state, action) => {
      return {
        ...state,
        cart: [...state.cart, action.payload],
      };
    },
    removeItemFromCart: (state, action) => {
      return {
        ...state,
        cart: state.cart.filter((cart) => cart.id !== action.payload),
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserCart.fulfilled, (state, action) => {
      state.cart = action.payload;
    });
  },
});
export const { addItemToCart, removeItemFromCart } = cartSlice.actions;
export default cartSlice.reducer;
